import React, { PureComponent } from 'react';
import { connect } from 'react-redux';

import * as phases from 'constants/phases';

/**
 * Return a component that knows whether it's currently in a storylet
 * @param {*} WrappedComponent
 */
export default function withCurrentlyInStorylet(WrappedComponent) {
  class WrapperComponent extends PureComponent {
    render() {
      const { storylet } = this.props;
      const currentlyInStorylet = !([
        phases.AVAILABLE,
      ].includes(storylet.phase));

      return (
        <WrappedComponent
          {...this.props}
          currentlyInStorylet={currentlyInStorylet}
        />
      );
    }
  }

  const mapStateToProps = ({ storylet }) => ({ storylet });

  return connect(mapStateToProps)(WrapperComponent);
}